import { IDonViTinhActions } from "../../action-types/category/IDonViTinhActionType";
import { IDonViTinhReducer } from "../../reducer-model/category/IDonViTinhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDonViTinhReducer = {
    status: eReducerStatusBase.is_not_initialization,
    donViTinhs: []
}
export const donViTinhReducer = (state: IDonViTinhReducer = iniState, action: IDonViTinhActions): IDonViTinhReducer => {
    switch (action.type) {
        case "DON_VI_TINH_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "DON_VI_TINH_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                donViTinhs: action.payload
            }
        case "DON_VI_TINH_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "DON_VI_TINH_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                donViTinhEditing: action.payload
            }
        case "DON_VI_TINH_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "DON_VI_TINH_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "DON_VI_TINH_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "DON_VI_TINH_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "DON_VI_TINH_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "DON_VI_TINH_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "DON_VI_TINH_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}